import {
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import DashboardLayout from "../../../components/layout/DashboardLayout";

import {
  useCustomerViewModel,
} from "../../../viewmodels/operation/customer/useCustomerViewModel";

const CreateCustomer =
  () => {

    const navigate =
      useNavigate();

    const {
      createCustomer,
    } =
      useCustomerViewModel();

    const [form, setForm] =
      useState<any>({

        name: "",
        email: "",

        addresses: [
          {
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            postalCode: "",
          },
        ],

        customerPhoneNumbers: [
          {
            name: "",
            phoneNumber: "",
          },
        ],

      });

    // ================= ADDRESS =================
    const updateAddress =
      (
        index: number,
        key: string,
        value: string
      ) => {

        const updated =
          [
            ...form.addresses,
          ];

        updated[index][key] =
          value;

        setForm({
          ...form,
          addresses:
            updated,
        });

      };

    const addAddress =
      () => {

        setForm({
          ...form,
          addresses: [
            ...form.addresses,
            {
              addressLine1: "",
              addressLine2: "",
              city: "",
              state: "",
              postalCode: "",
            },
          ],
        });

      };

    const removeAddress =
      (
        index: number
      ) => {

        const updated =
          form.addresses.filter(
            (
              _: any,
              i: number
            ) =>
              i !== index
          );

        setForm({
          ...form,
          addresses:
            updated,
        });

      };

    // ================= PHONE =================
    const updatePhone =
      (
        index: number,
        key: string,
        value: string
      ) => {

        const updated =
          [
            ...form.customerPhoneNumbers,
          ];

        updated[index][key] =
          value;

        setForm({
          ...form,
          customerPhoneNumbers:
            updated,
        });

      };

    const addPhone =
      () => {

        setForm({
          ...form,
          customerPhoneNumbers: [
            ...form.customerPhoneNumbers,
            {
              name: "",
              phoneNumber: "",
            },
          ],
        });

      };

    const removePhone =
      (
        index: number
      ) => {

        const updated =
          form.customerPhoneNumbers.filter(
            (
              _: any,
              i: number
            ) =>
              i !== index
          );

        setForm({
          ...form,
          customerPhoneNumbers:
            updated,
        });

      };

    // ================= SUBMIT =================
    const handleSubmit =
      async (
        e: any
      ) => {

        e.preventDefault();

        const success =
          await createCustomer(
            form
          );

        if (success) {

          navigate(
            "/customers"
          );

        }

      };

    return (
      <DashboardLayout>

        <div className="max-w-6xl mx-auto p-6">

          <div className="mb-6">

            <h1 className="text-2xl font-bold">
              Create Customer
            </h1>

          </div>

          <form
            onSubmit={
              handleSubmit
            }
            className="bg-white rounded-2xl shadow border border-slate-300 p-6 space-y-8"
          >

            {/* BASIC */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

              <div>

                <label className="block mb-2">
                  Customer Name
                </label>

                <input
                  value={
                    form.name
                  }
                  onChange={(e) =>
                    setForm({
                      ...form,
                      name:
                        e.target.value,
                    })
                  }
                  className="w-full border rounded-xl px-4 py-3"
                />

              </div>

              <div>

                <label className="block mb-2">
                  Email
                </label>

                <input
                  value={
                    form.email
                  }
                  onChange={(e) =>
                    setForm({
                      ...form,
                      email:
                        e.target.value,
                    })
                  }
                  className="w-full border rounded-xl px-4 py-3"
                />

              </div>

            </div>

            {/* ADDRESSES */}
            <div>

              <div className="flex justify-between items-center mb-4">

                <h3 className="text-lg font-semibold">
                  Addresses
                </h3>

                
              </div>

              <div className="space-y-5">

                {form.addresses.map(
                  (
                    address: any,
                    index: number
                  ) => (

                    <div
                      key={index}
                      className="border rounded-2xl p-5 bg-slate-50"
                    >

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                        <input
                          placeholder="Address Line 1"
                          value={
                            address.addressLine1
                          }
                          onChange={(e) =>
                            updateAddress(
                              index,
                              "addressLine1",
                              e.target.value
                            )
                          }
                          className="border rounded-xl px-4 py-3"
                        />

                        <input
                          placeholder="Address Line 2"
                          value={
                            address.addressLine2
                          }
                          onChange={(e) =>
                            updateAddress(
                              index,
                              "addressLine2",
                              e.target.value
                            )
                          }
                          className="border rounded-xl px-4 py-3"
                        />

                        <input
                          placeholder="City"
                          value={
                            address.city
                          }
                          onChange={(e) =>
                            updateAddress(
                              index,
                              "city",
                              e.target.value
                            )
                          }
                          className="border rounded-xl px-4 py-3"
                        />

                        <input
                          placeholder="State"
                          value={
                            address.state
                          }
                          onChange={(e) =>
                            updateAddress(
                              index,
                              "state",
                              e.target.value
                            )
                          }
                          className="border rounded-xl px-4 py-3"
                        />

                        <input
                          placeholder="Postal Code"
                          value={
                            address.postalCode
                          }
                          onChange={(e) =>
                            updateAddress(
                              index,
                              "postalCode",
                              e.target.value
                            )
                          }
                          className="border rounded-xl px-4 py-3"
                        />

                      </div>

                      {form.addresses.length >
                        1 && (

                        <button
                          type="button"
                          onClick={() =>
                            removeAddress(
                              index
                            )
                          }
                          className="mt-4 bg-red-600 text-white px-4 py-2 rounded-lg"
                        >
                          Remove
                        </button>

                      )}

                    </div>

                  )
                )}

              </div>

              <button
                  type="button"
                  onClick={
                    addAddress
                  }
                  className="bg-primary text-white px-4 py-2 rounded-lg mt-5"
                >
                  + Add Address
                </button>


            </div>

            {/* PHONE */}
            <div>

              <div className="flex justify-between items-center mb-4">

                <h3 className="text-lg font-semibold">
                  Phone Numbers
                </h3>

                

              </div>

              <div className="space-y-5">

                {form.customerPhoneNumbers.map(
                  (
                    phone: any,
                    index: number
                  ) => (

                    <div
                      key={index}
                      className="border rounded-2xl p-5 bg-slate-50"
                    >

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                        <input
                          placeholder="Contact Name"
                          value={
                            phone.name
                          }
                          onChange={(e) =>
                            updatePhone(
                              index,
                              "name",
                              e.target.value
                            )
                          }
                          className="border rounded-xl px-4 py-3"
                        />

                        <input
                          placeholder="Phone Number"
                          value={
                            phone.phoneNumber
                          }
                          onChange={(e) =>
                            updatePhone(
                              index,
                              "phoneNumber",
                              e.target.value
                            )
                          }
                          className="border rounded-xl px-4 py-3"
                        />

                      </div>

                      {form.customerPhoneNumbers
                        .length >
                        1 && (

                        <button
                          type="button"
                          onClick={() =>
                            removePhone(
                              index
                            )
                          }
                          className="mt-4 bg-red-600 text-white px-4 py-2 rounded-lg"
                        >
                          Remove
                        </button>

                      )}

                    </div>

                  )
                )}

              </div>

              <button
                  type="button"
                  onClick={
                    addPhone
                  }
                  className="bg-primary text-white px-4 py-2 rounded-lg mt-5"
                >
                  + Add Phone
                </button>

            </div>

            {/* ACTIONS */}
            <div className="flex justify-end gap-3 pt-4 border-t">

              <button
                type="button"
                onClick={() =>
                  navigate(
                    "/customers"
                  )
                }
                className="px-5 py-3 border rounded-xl"
              >
                Cancel
              </button>

              <button
                type="submit"
                className="px-5 py-3 bg-primary text-white rounded-xl"
              >
                Create Customer
              </button>

            </div>

          </form>

        </div>

      </DashboardLayout>
    );

  };

export default CreateCustomer;